import playerService from '../../../helpers/bitmovinPlayer';

export const useMuteControl = (isMuted: boolean, setIsMuted: (value: boolean) => void) => {
    const handleMute = () => {
        playerService.toggleMute();
        setIsMuted(!isMuted);
    };

    return { handleMute };
};
